// extracted by mini-css-extract-plugin
export default {"expandableContent__toggleButton":"ExpandableContent_expandableContent__toggleButton__f13rI"};